// config
import * as http from 'utils/http';
import config from 'config';
// utils

const getZipcodes = async ({ search, country }) => {
  country = country ? country : 'ES';
  search = search.replace(/-| /g, '');
  const data = await http.get(
    `${config.API_URL}zipcodes/?typeahead=${search}&country_id=${country}&page_size=20&enabled=true`
  );
  return data;
};

export default getZipcodes;
